import React from "react";
import { FormControl } from "@mui/material";
import { TextInputProps, StyledTextField } from "./types";

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  fullWidth = true,
  type = "text",
  helperText,
  error,
  ...rest
}) => {
  return (
    <FormControl error={error}>
      <StyledTextField
        {...rest}
        label={label}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value as string | number)
        }
        slotProps={{ input: { type: type }, inputLabel: { shrink: true } }}
        type={type}
        // placeholder={placeholder}
        fullWidth={fullWidth}
        variant="outlined"
        helperText={helperText}
      />
    </FormControl>
  );
};

export default TextInput;
